import React, {useEffect, useState} from 'react';
import {Card} from "../../../../components/card/card.jsx";
import {FaArrowLeft} from "react-icons/fa";
import InputForm from "../../../../components/input/input-form.jsx";
import Button from "../../../../components/button/button.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import AlertMessages from "../../../../components/messages/alert-message.js";
import myUserService from "../../../../services/web/my-user-service.js";
import {toast} from "react-toastify";

const MyUserNameWar = ({nameWar, setTarget, refetch, setIsLoading}) => {
    const [state, setState] = useState("");

    useEffect(() => {
        setState(nameWar);

        return () => setState("");
    }, [nameWar]);

    const submit = () => {
        setIsLoading(true);

        const formData = new FormData();
        formData.append("name_war", state);

        myUserService.updateNameWar(formData)
            .then(() => {
                toast.success("Salvo com sucesso");
                setTarget("info");
                refetch();
            })
            .catch(error => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? "Não foi possível prosseguir.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })
            .finally(() => setIsLoading(false))
    }

    return (
        <Card>
            <Card.Body>
                <h3 className="flex gap-2 items-center">
                <FaArrowLeft className="cursor-pointer font-normal" onClick={() => setTarget("info")}/>
                    Nome de guerra
                </h3>

                <div className="pt-[15px] px-[15px] mt-2 w-full">
                    <InputForm
                        id="nameWar"
                        value={state}
                        onChange={({target: {value}}) => setState(value)}
                        label="Nome de guerra"
                    />
                </div>

                <div className="flex justify-end p-[15px]">
                    <Button onClick={submit} actionFeedbackType='save'>

                        Salvar
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );
};

export default MyUserNameWar;